export default {
  title: "Завершение регистрации нового пользователя"
};
